import React from 'react';
import { Typography, Box, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const Home: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, px: 2 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome to SagaBot
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 2 }}>
          SagaBot is a Discord bot that helps you manage your cloud instances. With SagaBot, you can:
        </Typography>

        <Box component="ul" sx={{ mb: 4 }}>
          <Typography component="li" sx={{ mb: 2 }}>
            Register your cloud instances for Discord-based management
          </Typography>
          <Typography component="li" sx={{ mb: 2 }}>
            Start and stop your instances using Discord commands
          </Typography>
          <Typography component="li" sx={{ mb: 2 }}>
            Check the status of your instances at any time
          </Typography>
          <Typography component="li" sx={{ mb: 2 }}>
            Manage multiple instances across different cloud regions
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={Link}
            to="/register"
          >
            Register an Instance
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            component={Link}
            to="/instances"
          >
            View Instances
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}; 